import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./pages/root/root.routes').then((m) => m.routes),
  },
];
